// @flow

import { createPopper } from "@popperjs/core";

type PropsType = {
    $element: HTMLElement,
    text: ?string,
};

class Tooltip {
    props: PropsType;
    $element: HTMLElement;
    $tooltip: HTMLElement;
    $tooltipInner: HTMLElement;
    $tooltipArrow: HTMLElement;
    $tooltipDismiss: HTMLElement;
    popper: any;

    constructor(props: PropsType) {
        // set props and defaults
        this.props = {
            ...props,
            text: props.$element
                ? props.$element.getAttribute("data-tooltip")
                : "",
            variable: props.$element
                ? props.$element.getAttribute("data-tooltip-variable")
                : "",
        };

        // elements
        this.$element = props.$element;

        // variables

        // kick off
        this.init();
    }

    bindEvents() {
        if (this.$tooltipDismiss) {
            this.$tooltipDismiss.addEventListener("click", e => {
                e.stopPropagation();
                e.preventDefault();

                if (this.props.variable && this.props.variable.length > 0) {
                    // Check userid on variable if true
                    fetch("/user")
                        .then(data => {
                            const lastSegment = data.url.substring(
                                data.url.lastIndexOf("/") + 1
                            );
                            const users =
                                JSON.parse(
                                    localStorage.getItem(this.props.variable)
                                ) || {};
                            const entry = {
                                ...users,
                                [lastSegment]: true,
                            };
                            localStorage.setItem(
                                this.props.variable,
                                JSON.stringify(entry)
                            );
                            console.log(lastSegment);
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }

                this.$tooltip.remove();
            });
        }

        // window.addEventListener("scroll", () => {
        //     if (this.popper) {
        //         this.popper.update();
        //     }
        // });
    }

    init() {
        // if variable is set - check localStorage

        if (this.props.variable && this.props.variable.length > 0) {
            fetch("/user")
                .then(data => {
                    const lastSegment = data.url.substring(
                        data.url.lastIndexOf("/") + 1
                    );
                    const users =
                        JSON.parse(localStorage.getItem(this.props.variable)) ||
                        {};
                    console.log(users[lastSegment]);
                    if (!users[lastSegment]) {
                        // append element
                        this.createToolTipElements();

                        // setup popper
                        this.popper = createPopper(
                            this.$element,
                            this.$tooltip,
                            {
                                placement: this.props.placement || "top-start",
                                strategy: "fixed",
                                modifiers: [
                                    {
                                        name: "arrow",
                                        options: {
                                            element: this.$tooltipArrow,
                                            padding: 30,
                                        },
                                    },
                                    {
                                        name: "offset",
                                        options: {
                                            offset: [0, 10],
                                        },
                                    },
                                    {
                                        name: "flip",
                                        enabled: false,
                                    },
                                ],
                            }
                        );

                        // bind events
                        this.bindEvents();
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            // append element
            this.createToolTipElements();

            // setup popper
            this.popper = createPopper(this.$element, this.$tooltip, {
                placement: this.props.placement || "top-start",
                strategy: "fixed",
                modifiers: [
                    {
                        name: "arrow",
                        options: {
                            element: this.$tooltipArrow,
                            padding: 30,
                        },
                    },
                    {
                        name: "offset",
                        options: {
                            offset: [0, 10],
                        },
                    },
                    {
                        name: "flip",
                        enabled: false,
                    },
                ],
            });

            // bind events
            this.bindEvents();
        }
    }

    createToolTipElements() {
        // tooltip wrapper
        this.$tooltip = document.createElement("div");
        this.$tooltip.classList.add("tooltip");
        if (this.props.placement) {
            this.$tooltip.classList.add(`tooltip--${this.props.placement}`);
        }
        if (this.props.dismiss) {
            this.$tooltip.classList.add(`tooltip--dismiss`);
        }
        this.$tooltip.setAttribute("role", "tooltip");

        // tooltip inner
        this.$tooltipInner = document.createElement("div");
        this.$tooltipInner.classList.add("tooltip__inner");
        this.$tooltipInner.innerHTML = this.props.text || "";

        if (this.props.dismiss) {
            this.$tooltipDismiss = document.createElement("a");
            this.$tooltipDismiss.classList.add("tooltip__dismiss");
            this.$tooltipDismiss.innerHTML = "Got it";
            this.$tooltipInner.append(this.$tooltipDismiss);
        }

        this.$tooltip.append(this.$tooltipInner);

        // tooltip arrow
        this.$tooltipArrow = document.createElement("div");
        this.$tooltipArrow.classList.add("tooltip__arrow");
        this.$tooltipArrow.setAttribute("data-popper-arrow", "");
        this.$tooltip.append(this.$tooltipArrow);
        this.$element.append(this.$tooltip);
    }
}

export default Tooltip;
